export default __webpack_public_path__ + "static/media/phantom.47882ea3.svg";